import { render, staticRenderFns } from "./regi.vue?vue&type=template&id=76dbb552&"
import script from "./regi.vue?vue&type=script&lang=js&"
export * from "./regi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports